'use client';

import { useEffect } from 'react';

export default function PwaServiceWorkerManager() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }

    let registration: ServiceWorkerRegistration | null = null;

    const registerServiceWorker = async () => {
      registration = await navigator.serviceWorker.register('/OneSignalSDKWorker.js', { scope: '/' });

      registration.update().catch(() => {
        // ignore update errors
      });
    };

    registerServiceWorker().catch(() => {
      // ignore registration errors
    });

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        registration?.update().catch(() => {
          // ignore update errors
        });
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    const updateInterval = window.setInterval(() => {
      registration?.update().catch(() => {
        // ignore update errors
      });
    }, 10 * 60 * 1000);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.clearInterval(updateInterval);
    };
  }, []);

  return null;
}
